import { render, staticRenderFns } from "./configAiChat.vue?vue&type=template&id=18bfdbab&scoped=true&"
import script from "./configAiChat.vue?vue&type=script&lang=js&"
export * from "./configAiChat.vue?vue&type=script&lang=js&"
import style0 from "./configAiChat.vue?vue&type=style&index=0&id=18bfdbab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bfdbab",
  null
  
)

export default component.exports